import { render, staticRenderFns } from "./FileUploadBoxCopy.vue?vue&type=template&id=af05bffe&scoped=true&"
import script from "./FileUploadBoxCopy.vue?vue&type=script&lang=js&"
export * from "./FileUploadBoxCopy.vue?vue&type=script&lang=js&"
import style0 from "./FileUploadBoxCopy.vue?vue&type=style&index=0&id=af05bffe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af05bffe",
  null
  
)

export default component.exports